/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";

import { values } from "lodash";
import { connect } from "react-redux";

import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceNightWorkerSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    const hasPreviouslyDisclosedMedicalCondition = (getAnswerToQuestionWithId(values(props.questions || {}),
        questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalCondition) === MultiButtonQuestion.YesOption);

    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.NightWorker}
        >
            <h4>Does your job involve any of the following</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.OfficeDuties),
                    getQuestionConfig(props.questionConfigs, questionIds.OfficeDutiesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Driving),
                    getQuestionConfig(props.questionConfigs, questionIds.DrivingFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ManualHandling),
                    getQuestionConfig(props.questionConfigs, questionIds.ManualHandlingFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.OperatingMachinery),
                    getQuestionConfig(props.questionConfigs, questionIds.OperatingMachineryFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.TypicalPatternNightWork)} readonly={props.readonly} multiline />
            <h4>Additional Questions</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HealthSymptomsCausedByNightWork),
                    getQuestionConfig(props.questionConfigs, questionIds.HealthSymptomsCausedByNightWorkFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RegularPillsOrMedication),
                    getQuestionConfig(props.questionConfigs, questionIds.RegularPillsOrMedicationFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AttendingHospitalGpReceivingMedicalTreatment),
                    getQuestionConfig(props.questionConfigs, questionIds.AttendingHospitalGpReceivingMedicalTreatmentFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Do you have any of the following health conditions?</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CardiovascularProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.CardiovascularProblemsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExpectantMother),
                    getQuestionConfig(props.questionConfigs, questionIds.ExpectantMotherFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {<MultiButtonQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(
                    props.questionConfigs,
                    questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalCondition
                )}
            />}
            {hasPreviouslyDisclosedMedicalCondition &&
                YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalConditionChanges),
                        getQuestionConfig(props.questionConfigs, questionIds.NightWorkerPreviouslyDisclosedSameMedicalConditionChanges)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

/**
 * @deprecated Replaced by HealthSurveillanceNightWorkerSection when FeatureToggleNames.EnableNewNightWorkerQuestions is toggled on
 * When the toggle is removed this can be renamed to ReadonlyHealthSurveillanceNightWorkerSection as it will need to be kept for historical data
 */
// eslint-disable-next-line max-len
export const OldHealthSurveillanceNightWorkerSection = connect(makeMapStateToQuestionnaireSectionProps(sections.NightWorker.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceNightWorkerSectionUnconnected);
